/**************************************************
 * Nombre:       BarraCell
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {ButtonBase, Drawer, Grid, IconButton, InputAdornment, TextField, Typography} from "@mui/material";
import logo from '../../Recursos/logo_color.svg'
import logoBlanco from '../../Recursos/logo_blanco.svg'
import {Close, Menu, Search} from '@mui/icons-material'
import {useState} from "react";
import {SECCIONES} from "../../Constantes";
import {useNavigate} from "react-router";
import {theme} from "../../Tema";
import {useIrRuta} from "../../Utilidades/useIrRuta";

const BarraCell = ({negro}) => {
    const navigate = useNavigate()
    const {ir} = useIrRuta()
    const [open, setOpen] = useState(false)
    const [palabra, setPalabra] = useState('')

    return (
        <Grid
            container
            justifyContent={'space-between'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{backgroundColor: '#fff', px: 3, py: 3}}
        >

            <img
                onClick={() => navigate('/Home')}
                src={logo} width={180} height={'auto'} style={{marginTop: -5}}/>

            <IconButton
                onClick={() => setOpen(true)}
                sx={{backgroundColor: theme.palette.primary.main, mt: 0}}
            >
                <Menu sx={{fill: '#fff'}}/>
            </IconButton>

            <Drawer open={open} onClose={() => setOpen(false)}
                    anchor={'right'}
            >

                <Grid container size={{xs: 12, ms: 12, md: 12}}>
                    <IconButton
                        onClick={() => setOpen(false)}
                    >
                        <Close sx={{fill: '#fff'}}/>
                    </IconButton>
                </Grid>

                <Grid container size={{xs: 12, ms: 12, md: 12}}
                      sx={{width: 300, p: 2, marginTop: 2, justifyContent: 'center'}}>


                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: 'center', marginTop: 2}}>
                        <TextField
                            size={'small'}
                            variant={'outlined'}
                            color={'secondary'}
                            label={'Buscar producto'}
                            fullWidth={false}
                            sx={{width: 300}}
                            value={palabra}
                            onChange={e => setPalabra(e.target.value)}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') {
                                    navigate('/Catalogo/Palabra/' + palabra)
                                    setOpen(false)
                                }
                            }}

                            slotProps={{
                                input: {
                                    endAdornment: (
                                        <InputAdornment
                                            onClick={() => {
                                                if (palabra) {
                                                    navigate('/Catalogo/Palabra/' + palabra)
                                                    setOpen(false)
                                                }
                                            }
                                            }
                                            position="end"
                                            sx={{cursor: 'pointer'}}
                                        >
                                            <Search color={'secondary'}/>
                                        </InputAdornment>
                                    ),
                                    disableUnderline: true,
                                    sx: {borderRadius: 10, color: '#fff', fontWeight: 500}
                                },
                                inputLabel: {
                                    sx: {marginLeft: -0.5, borderRadius: 10, color: '#fff'}
                                }
                            }
                            }
                        />
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: 'center', marginTop: 2}}>
                        <ButtonBase
                            onClick={() => {
                                setOpen(false)
                                setTimeout(() => {
                                    navigate('/Home')
                                }, 500)
                            }}

                        >
                            <Typography
                                sx={{
                                    color: '#fff',
                                    fontSize: 20,
                                    fontWeight: 600,
                                    textAlign: 'center'
                                }}>Inicio</Typography>
                        </ButtonBase>
                    </Grid>

                    {SECCIONES.map((item, index) => (
                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'center', marginTop: 2}}>
                            <ButtonBase
                                onClick={() => {
                                    setOpen(false)
                                    setTimeout(() => {
                                        ir(item)
                                    }, 500)
                                }}

                            >
                                <Typography
                                    sx={{
                                        color: '#fff',
                                        fontSize: 20,
                                        fontWeight: 600,
                                        textAlign: 'center'
                                    }}>{item}</Typography>
                            </ButtonBase>
                        </Grid>
                    ))}


                    <Grid container size={{xs: 12, ms: 12, md: 12}}
                          sx={{bottom: '2%', justifyContent: 'center', marginTop: 50}}>
                        <img src={logoBlanco} width={220} height={'auto'}/>
                    </Grid>

                    <Grid container size={{xs: 10, ms: 12, md: 12}}
                          sx={{bottom: '2%', justifyContent: 'center', marginTop: 2}}>
                        {/*REDES.map((item, index) => {
                            return (
                                <Grid container size={{xs: 3, ms: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                    <IconButton
                                        onClick={() => irUrl(item.url)}
                                    >
                                        <img src={item.imgColor} width={32} height={'auto'}/>
                                    </IconButton>
                                </Grid>
                            )
                        })*/}
                    </Grid>


                </Grid>

            </Drawer>

        </Grid>
    )

}
export default BarraCell